/** Per file/page UI state stored in the project takeoff document. */

export const pageKey = (fileId, page) => `${fileId}:${page}`;

export const getPageState = (doc, fileId, page) => ({
  rotation: 0,
  feetPerUnit: null,
  scaleLabel: "No scale",
  name: `Page ${page}`,
  bookmarked: false,
  highlights: [],
  ...(doc?.pages?.[pageKey(fileId, page)] || {}),
});

/** apply fn to the page's state object inside a mutate() draft. */
export const editPageState = (draft, fileId, page, fn) => {
  const key = pageKey(fileId, page);
  const cur = {
    rotation: 0, feetPerUnit: null, scaleLabel: "No scale",
    name: `Page ${page}`, bookmarked: false, highlights: [],
    ...(draft.pages?.[key] || {}),
  };
  fn(cur);
  if (!draft.pages) draft.pages = {};
  draft.pages[key] = cur;
};

/** Rotate a point set with the page frame so marks stay glued to the ink. */
export const rotatePoints = (pts, unitHOld, unitHNew, dir) => {
  // dir: +1 = 90° CW, -1 = 90° CCW. Frames are 1000 x unitH.
  return (pts || []).map((p) => {
    const fx = p.x / 1000, fy = p.y / unitHOld;
    const fx2 = dir > 0 ? 1 - fy : fy;
    const fy2 = dir > 0 ? fx : 1 - fx;
    return { x: fx2 * 1000, y: fy2 * unitHNew };
  });
};
